import { AttachDetachAction } from './attach-detach-action.enum';
import { TransportScope } from "../../../common/model/transport.model";
export class AttachDetachDetails {

  transportId: number;
  carrier: string;
  driver: string;
  numberPlate: string;
  cargo: string;
  orderReference: string;
  trailerNumberPlate: string;
  trailerIdentifier: string;
  swapTrailerNumber: string;
  transportScope: TransportScope;
  targetTransportScope: TransportScope;
  action: AttachDetachAction;
  truckId: number;
  identifier: string;
  warningDictionaryKey: string;
  confirmEnabled: boolean;
  trailerSwapTargetId: number;
  useAsServiceTruck: boolean;
  targetStationId: number;
}
